import React from 'react';
import { GiftIcon } from 'lucide-react';
import { BONUS_ITEMS } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
export function BonusSection() {
  return <section className="py-16 md:py-24 bg-zinc-950 px-4" data-id="element-27">
      <div className="max-w-5xl mx-auto" data-id="element-28">
        <div className="text-center mb-16" data-id="element-29">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-30">
            E in più, oggi ricevi anche 4 Bonus Gratuiti
          </h2>
          <p className="text-xl text-stone-300 max-w-2xl mx-auto" data-id="element-31">
            Strumenti extra pensati per aiutarti ad applicare tutto più
            velocemente e con risultati ancora migliori.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-32">
          {BONUS_ITEMS.map((bonus, index) => <div key={index} onClick={scrollToOffer} className="bg-white rounded-2xl overflow-hidden flex flex-col sm:flex-row cursor-pointer hover:shadow-[0_0_20px_rgba(250,204,21,0.3)] transition-all group" data-id="element-33">
              <div className="sm:w-2/5 bg-stone-100 p-6 flex flex-col items-center justify-center relative border-b sm:border-b-0 sm:border-r border-gray-200" data-id="element-34">
                <GiftIcon className="w-16 h-16 text-amber-500 mb-4 group-hover:scale-110 transition-transform" data-id="element-35" />
                <div className="absolute top-4 left-4 bg-red-700 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md" data-id="element-36">
                  GRATIS per oggi
                </div>
              </div>
              <div className="sm:w-3/5 p-6 flex flex-col justify-center" data-id="element-37">
                <div className="flex items-center space-x-2 mb-2" data-id="element-38">
                  <span className="text-amber-600 font-bold text-sm uppercase tracking-wider" data-id="element-39">
                    Bonus {index + 1}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-40">
                  {bonus.title}
                </h3>
                <p className="text-stone-600 mb-4 text-sm leading-relaxed" data-id="element-41">
                  {bonus.description}
                </p>
                <div className="mt-auto" data-id="element-42">
                  <span className="text-gray-400 line-through text-sm mr-2" data-id="element-43">
                    Valore: {bonus.value}
                  </span>
                  <span className="text-green-600 font-bold" data-id="element-44">Oggi GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-white/10 border border-white/20 rounded-2xl p-6 text-center mb-10 max-w-2xl mx-auto" data-id="element-45">
          <p className="text-xl text-white font-medium" data-id="element-46">
            🎁 In totale riceverai{' '}
            <span className="text-amber-400 font-bold" data-id="element-47">9 risorse complete</span>{' '}
            per migliorare davvero il tuo modo di insegnare tango
          </p>
        </div>

        <div className="text-center" data-id="element-48">
          <button onClick={scrollToOffer} className="bg-amber-500 hover:bg-amber-400 text-stone-950 rounded-full py-5 px-10 font-bold text-xl md:text-2xl shadow-[0_0_20px_rgba(250,204,21,0.4)] transition-all" data-id="element-49">
            Voglio Tutto il Pacchetto Ora
          </button>
        </div>
      </div>
    </section>;
}